import { UpdateItemMandatoryPropertiesStitchActionName, } from 'owa-mail-store-actions';
import { lazyUpdateOnItemMandatoryPropertiesChange } from 'owa-mail-reading-pane-store';
import { subscribe } from 'satcheljs/lib/legacy/stitch';
export default function subscribeToUpdateLoadedConversationStitch() {
    subscribe(UpdateItemMandatoryPropertiesStitchActionName, lazyUpdateOnItemMandatoryPropertiesChange.importAndExecute);
}
//# sourceMappingURL=updateItemMandatoryPropertiesStitch.js.map